const data = {
    columns: [
    {
        label: 'Return Location',
        field: 'Location',
        sort: 'disabled',
        width: 150
    },
    {
        label: 'RO #',
        field: 'RO',
        sort: 'disabled',
        width: 150
    },
    {
        label: 'SO #',
        field: 'SO',
        sort: 'disabled',
        width: 150
    },
    {
        label: 'Item ID',
        field: 'Item',
        sort: 'disabled',
        width: 100
    },
    {
        label: 'Qty',
        field: 'Qty',
        sort: 'disabled',
        width: 100
    },
    {
        label: 'Brand',
        field: 'Brand',
        sort: 'disabled',
        width: 150
    },
    {
        label: 'Supplier Name',
        field: 'Supplier',
        sort: 'disabled',
        width: 100
    },
    {
        label: 'CBL#',
        field: 'CBL',
        sort: 'disabled',
        width: 200
    },
    {
        label: 'UBL#',
        field: 'UBL',
        sort: 'disabled',
        width: 200
    },
    {
        label: 'Supplier PO #',
        field: 'supplier_po',
        sort: 'disabled',
        width: 150
    },
    {
        label: 'Carrier Ref#',
        field: 'carrier',
        sort: 'disabled',
        width: 150
    }
    ],
    rows: [
    {
        Location: '001 Melbourne',
        RO: '12344556',
        SO: '12344556',
        Item: '12344556211',
        Qty: '2',
        Brand: 'Brand name',
        Supplier: 'MYER Market',
        CBL: '12344556211',
        UBL: '12344556211',
        carrier: '12344556211',
    }
    ]
    };

    export default data;